/* unplugin-vue-components disabled */import script from "./release.vue?vue&type=script&setup=true&lang=js"
export * from "./release.vue?vue&type=script&setup=true&lang=js"

import "./release.vue?vue&type=style&index=0&id=20e10b06&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20e10b06"]])

export default __exports__